
    <footer class="main-footer text-sm">
      <strong>Copyright &copy; {{ currentYear }} <a href="https://www.devcare.com/" target="_blank">DevCare Solutions</a>.</strong>
      All rights reserved<strong>.<a [routerLink]="['/privacy-policy']" target="_blank"> Privacy Policy</a></strong>
      <strong> - </strong>
      <strong><a [routerLink]="['/terms-and-conditions']" target="_blank">Terms & Conditions</a></strong>
      <div class="float-right d-none d-sm-inline-block">
        <b>Version</b> 0.0.0
      </div>
    </footer>
